"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _TwelveColumnGrid = _interopRequireDefault(require("../Grid/TwelveColumnGrid/TwelveColumnGrid"));
var _excluded = ["copy"],
  _excluded2 = ["node"];
var _templateObject, _templateObject2;
var StyledReactMarkdown = (0, _styledComponents.default)(_TwelveColumnGrid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  color: #FFFFFF;\n"])));
var StyledAnnouncementParagraph = (0, _styledComponents.default)(_Paragraph.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 6px 20px;\n\n  b {\n    font-weight: 600;\n  }\n  a {\n    color: #f3fccc !important;\n    text-decoration: underline;\n  }\n\n  @media (min-width: ", ") {\n    font-size: 18px;\n    line-height: 26px;\n  }\n"])), _bfBaseStyles.Breakpoints.s);
var Announcement = function Announcement(_ref) {
  var copy = _ref.copy,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(StyledReactMarkdown, Object.assign({
    spansFullPage: true
  }, props), _react.default.createElement(_reactMarkdown.default, {
    children: copy,
    components: {
      p: function p(_ref2) {
        var node = _ref2.node,
          props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
        return _react.default.createElement(StyledAnnouncementParagraph, props);
      }
    }
  }));
};
var _default = Announcement;
exports.default = _default;